export const getBrandTranslations = async (code, brand) => {
  try {
    const response = await fetch(`/locales/${code}/${brand}/translation.json`);

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (error) {
    return null;
  }
};